<template>
	<StandardModal
		open
		:title="person.fullname"
		:confirmText="$t('admin_people_deactivate_button')"
		:confirmProps="{ danger: true, loading: isProcessing }"
		@confirm="deactivateUser"
		@cancel="close"
		small
		ref="modal"
	>
		<div class="modal-wrapper">
			<DeactivatedUserIcon halo />
			{{ $t('admin_people_deactivate_warning_label') }}
		</div>
	</StandardModal>
</template>

<script>
import { StandardModal } from '@/components/common'
import { DeactivatedUserIcon } from '@/icons'
import { del } from '../common'
import { storage } from '@/helpers/utils'

export default {
	name: 'DeactivatePersonModal',
	data() {
		return {
			isProcessing: false,
			processingError: false,
		}
	},
	emits: ['deactivate', 'close'],
	components: { StandardModal, DeactivatedUserIcon },
	props: {
		person: Object,
	},
	methods: {
		async deactivateUser() {
			this.processingError = false
			this.isProcessing = true
			try {
				await del(`/organization/users/${this.person.id}`)
				storage.set('org_mgmt_changed_people', true)
				this.$emit('deactivate', this.person.id)
				this.$alert.success(
					this.$t('admin_people_confirmation_person_deactivated_label')
				)
				this.close()
			} catch (e) {
				this.isProcessing = false
				this.$refs.modal.$alert.error(this.$t('common_api_error_save'))
			}
		},
		close() {
			this.$emit('close')
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.modal-wrapper {
	@include flex-column-center;
	max-width: 300px;
	margin: 24px auto;
	text-align: center;
	.pronto-icon {
		color: var(--red-200);
		font-size: 50px;
		margin-bottom: 24px;
	}
}
</style>
